interface ILineListProps {
  value?: string | string[] | null
  className?: string
}

const LineList = ({ value, className = '' }: ILineListProps) => {
  const normalized = Array.isArray(value) ? value : (value ?? '').replace(/\r\n/g, '\n').split('\n') // supports both string and array

  return (
    <>
      {normalized.filter(Boolean).map((item, index) => (
        <li className={className} key={index}>
          {item}
        </li>
      ))}
    </>
  )
}

export default LineList
